module.exports = __webpack_public_path__ + "aa4c552d987ffc8da89094f0c7794527.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/yichan/yichan-title.png
// module id = 1259
// module chunks = 0